import { Reveal } from "./Reveal";

// ---------------------------------------------------------------------------
// FACTS — quick numeric strip right under the hero.
// Only real, verifiable numbers (no invented metrics).
// Staggered reveal on each stat.
// ---------------------------------------------------------------------------

const facts = [
  { big: "7 a 10", label: "días para tener el sistema funcionando" },
  { big: "+30", label: "negocios reales ya trabajando con CreceLocal" },
  { big: "1", label: "sistema conectado, no siete herramientas sueltas" },
  { big: "0", label: "contrato — cancelás cuando quieras" },
];

export function HomeFacts() {
  return (
    <section className="border-b border-[#221F2A]">
      <div
        className="mx-auto grid"
        style={{
          maxWidth: 1240,
          gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
        }}
      >
        {facts.map((f, i) => (
          <Reveal key={f.label} delay={i * 0.08}>
            <div className="px-6 py-9 border-r border-[#221F2A] last:border-r-0">
              <div
                className="text-[#EEEDF2]"
                style={{
                  fontSize: "clamp(40px,4.4vw,56px)",
                  lineHeight: 1,
                  letterSpacing: "-0.02em",
                }}
              >
                {f.big}
              </div>
              <div className="text-[14.5px] text-[#9C98A6] mt-2.5">
                {f.label}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
